import { createComponent, customMap } from 'redux-form-antd';
import { Upload } from 'antd'
import { UploadChangeParam } from 'antd/lib/upload';

// tslint:disable-next-line:no-any
function mapFunction(mapProps: any, { input: { onChange } } : any) {
    return {
      ...mapProps,
      // tslint:disable-next-line:no-any
      onChange: (info: UploadChangeParam) => onChange(info)
    };
  }
const uploadFieldMap = customMap(mapFunction);

export default createComponent(Upload, uploadFieldMap);


// WEBPACK FOOTER //
// ./src/reduxFormAntd/UploadField.ts